import React, { useCallback, useEffect, useRef } from 'react';

import { StyledMarkdownContainer } from '@mewa/ui';

import { getAssetUrl } from '../../../../libs/transform-asset-url';

export type MarkdownContentWithImageDescriptionProps = {
  html: string;
  id?: string;
};

export const MarkdownContentWithImage = ({
  html,
  id,
}: MarkdownContentWithImageDescriptionProps) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const hasInsertedImageDescriptions = useRef(false);

  const cleanUpContent = useCallback(() => {
    if (elementRef.current) {
      elementRef.current.querySelectorAll('img').forEach(replaceImageSrc);
      elementRef.current
        .querySelectorAll('a')
        .forEach(openExternalLinkInNewTab);
    }
  }, [elementRef]);

  useEffect(() => {
    if (!hasInsertedImageDescriptions.current) {
      cleanUpContent();
      hasInsertedImageDescriptions.current = true;
    }
  }, [cleanUpContent]);

  return <StyledMarkdownContainer ref={elementRef} html={html} id={id} />;
};

const replaceImageSrc = (imgElement: HTMLImageElement) => {
  const src = imgElement.getAttribute('src');

  if (src) {
    const newSrc = getAssetUrl(src, process.env['GATSBY_ASSETS_HOST']);
    imgElement.setAttribute('src', newSrc ?? src);
    imgElement.removeAttribute('style');
  }
};

const openExternalLinkInNewTab = (anchorElement: HTMLAnchorElement) => {
  if (anchorElement.getAttribute('href')?.startsWith('http')) {
    anchorElement.setAttribute('target', '_blank');

    if (anchorElement.parentElement?.childNodes.length === 1) {
      addExternalLinkIcon(anchorElement);
    }
  }
};

const addExternalLinkIcon = (anchorElement: HTMLAnchorElement) => {
  const svgString = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 48" fill="none">
    <path fill="currentColor" fill-rule="evenodd"
          d="M38.064 10.446v9.635h-2V13.86L23.74 26.185l-1.414-1.414L34.65 12.446h-6.22v-2h9.634Zm-25.129 6.968v18.14h18.14v2h-20.14v-20.14h2Z" clip-rule="evenodd"/>
</svg>`;
  const span = document.createElement('span');
  span.innerHTML = svgString;
  span.children[0]?.setAttribute(
    'style',
    'margin-bottom:calc(var(--spacer-xs) * -1);height:calc(var(--font-size-body) * var(--line-height-body) * 1.2);',
  );
  anchorElement.insertBefore(span, anchorElement.firstChild);
};
